/* This view represents a members list for the book club, listing the current book club members and 
   the the roles they have. Each member has a status bar for reading progress of the current book. 
   For admin, pending requests will also show up here where they can accept/reject the request. 
 */

import { ProfileImg } from "../../components/ProfileIMG";
import { Check, X, Crown } from "lucide-react";
import { sortMembersByProgress } from "../../utils";


export function MembersTabView(props){
   const isAdmin = props.currentClub.adminId === props.currentUser.userId;
   const pendingRequests = [...props.currentClub.pendingRequests];
   const members = [...props.members];

   //console.log("pending requests length", pendingRequests);
   console.log("current club", props.currentClub);
   console.log("members", props.members);

   function handleAcceptRequestACB(clubId, userId){
      props.onAcceptRequest(clubId, userId);
      // probably something to make the pending request disappear?? idk
      console.log("onacceptrequest", clubId, userId)
   }

   function handleRejectRequestACB(clubId, userId){
      props.onRejectRequest(clubId, userId);

   }

   function renderRequestsCB(request){
      console.log("request", request)
      return <div key={request.userId}
         className="bg-orange-50 rounded-lg p-2 border border-orange-200 flex items-center justify-between"
      >
         <div className="flex items-center gap-3">
            <ProfileImg svgString={request.profileImg} className="w-12 h-12 rounded-full"/>
            <p className="text-amber-900 h-12 flex items-center">{request.name}</p>
         </div>
         <div className="flex gap-2">
            {/* Accept Request Button */}
            <button
               title="Accept Request"
               onClick={()=>handleAcceptRequestACB(props.clubId,request.userId)}
               className="p-2 bg-green-600 text-white !rounded-lg hover:bg-green-700 transition-colors"
            >
               <Check className="w-4 h-4" />
            </button>
            {/* Reject Request Button */}
            <button 
               title="Reject Request"
               onClick={()=>handleRejectRequestACB(props.clubId, request.userId)}
               className="p-2 bg-red-600 text-white !rounded-lg hover:bg-red-700 transition-colors"
            >
               <X className="w-4 h-4"/>
            </button>
         </div>
      </div>
   }

   function renderMembersCB(member){

      
      return <div  key={member.userId} className="bg-white rounded-lg p-4 !border border-amber-200">
            {/* Profile pic and member name */}
            <div className="flex items-center gap-2">
                  <ProfileImg svgString={member.profileImg}/>
               <div className="flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                     <span className="text-amber-900">
                        {member.name}
                     </span>
                     {/* Admin badge */}
                     {member.userId === props.currentClub.adminId && (
                        <div className="flex items-center gap-1 px-2 py-1 bg-amber-100 text-amber-700 rounded-full">
                            <Crown className="w-3 h-3" />
                            <span>Admin</span>
                        </div>
                     )}
                  </div>
               </div>
            </div>

            {/* Reading progress */}
            {props.currentBook && (()=>{
               const progressPercentage = member.readingProgress / props.currentBook.pages;
               return(
               <div className="mt-3">
                  <div className="flex items-center justify-between mb-0 mt-0.5">
                     <span className="text-amber-700">Reading Progress</span>
                     <span className="text-amber-600">
                        {member.readingProgress} / {props.currentBook.pages} pages
                     </span>
                  </div>
                  <div className="w-full h-2 bg-amber-100 rounded-full overflow-hidden mt-0.5">
                     <div 
                        className="h-full bg-gradient-to-r from-amber-500 to-orange-600" 
                        style={{ width:`${progressPercentage*100}%`}}>
                     </div>
                  </div>
               </div>
            )})()}
         </div>
   }
   

   return <div className="space-y-6">
      {/* Pending Requests, for admin only */}
      {isAdmin && pendingRequests.length> 0 && (
         <div>
            <p className="font-medium text-amber-900 mb-4">Pending Requests ({pendingRequests.length})</p>
            <div className="space-y-3">
            {pendingRequests.filter(request => request != null).map(renderRequestsCB)}
            </div>
         </div>
      )}

      {/* Current Club */}
      <div>
         <h4 className="text-amber-900 mb-4"> Members ({members.length}) </h4>
         <div className="space-y-3">
            {sortMembersByProgress(members.filter(member => member != null)).map(renderMembersCB)}

         </div>
      </div>
   </div>
}